<template>
  <o-view>
    <o-nav-bar title="Thema" />
    <o-section :is-transparent="true">
      <div class="c-theme-setting">
        <label for="color">Partnerkleur (HEX)</label>
        <input
          type="color"
          id="color"
          :value="$store.state.primaryColor"
          @input="updateColor"
        />
        <input
          type="text"
          :value="$store.state.primaryColor"
          @input="updateColor"
        />
      </div>
      <div class="c-theme-setting">
        <label for="name">Partnernaam</label>
        <input
          type="text"
          id="name"
          :value="$store.state.partnerName"
          @input="updateName"
        />
      </div>
      <div class="c-theme-setting">
        <label for="ticketsbutton">
          <input
            type="checkbox"
            id="ticketsbutton"
            :checked="$store.state.showTicketsButton"
            @change="updateShowTicketsButton"
          />
          Toon "Koop ticket"
        </label>
      </div>
      <div class="c-theme-setting">
        <label for="walletbutton">
          <input
            type="checkbox"
            id="walletbutton"
            :checked="$store.state.showWalletButton"
            @change="updateShowWalletButton"
          />
          Toon "Mijn tickets"
        </label>
      </div>
      <div class="c-theme-setting">
        <label for="mobilitsbutton">
          <input
            type="checkbox"
            id="mobilitsbutton"
            :checked="$store.state.showMobilits"
            @change="updateShowMobilits"
          />
          Toon Mobilits in sales flows
        </label>
      </div>
      <div class="c-theme-setting">
        <label for="favoritebutton">
          <input
            type="checkbox"
            id="favoritebutton"
            :checked="$store.state.showFavoriteButton"
            @change="updateShowFavoriteButton"
          />
          Toon favorietenknop in sales flows
        </label>
      </div>
      <div class="c-theme-setting">
        <label for="supportbutton">
          <input
            type="checkbox"
            id="supportbutton"
            :checked="$store.state.showSupportButton"
            @change="updateShowSupportButton"
          />
          Toon supportknop in navigatiebalk
        </label>
      </div>
      <div class="c-theme-setting">
        <label for="nmbssupportbutton">
          <input
            type="checkbox"
            id="nmbssupportbutton"
            :checked="$store.state.showNMBSSupport"
            @change="updateShowNMBSSupport"
          />
          Toon supportgegevens in salesflow
        </label>
      </div>
      <div class="c-theme-setting">
        <o-button @click="goFullScreen" label="Volledig scherm" />
      </div>
      <div class="c-theme-setting">
        <o-button @click="resetTheme" label="Reset thema" />
      </div>
      <div class="c-theme-setting">
        <o-button @click="goHome" label="Ga naar het startscherm" />
      </div>
    </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'SetTheme',
  methods: {
    updateColor(e) {
      this.$store.commit('setPrimaryColor', e.target.value)
    },
    updateName(e) {
      this.$store.commit('setPartnerName', e.target.value)
    },
    updateShowTicketsButton(e) {
      this.$store.commit('setShowTicketsButton', e.target.checked)
    },
    updateShowWalletButton(e) {
      this.$store.commit('setShowWalletButton', e.target.checked)
    },
    updateShowMobilits(e) {
      this.$store.commit('setShowMobilits', e.target.checked)
    },
    updateShowFavoriteButton(e) {
      this.$store.commit('setShowFavoriteButton', e.target.checked)
    },
    updateShowSupportButton(e) {
      this.$store.commit('setShowSupportButton', e.target.checked)
    },
    updateShowNMBSSupport(e) {
      this.$store.commit('setShowNMBSSupport', e.target.checked)
    },
    resetTheme() {
      this.$store.commit('resetTheme')
    },
    goHome() {
      this.$router.push('/')
    },
    goFullScreen() {
      document.documentElement.webkitRequestFullscreen()
    }
  }
}
</script>

<style lang="scss">
.c-theme-setting {
  label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.8rem;
  }

  input[type='color'] {
    margin-bottom: 0.8rem;
  }

  input[type='text'] {
    color: inherit;
    display: block;
    font: inherit;
    padding: 0.8rem;
    width: 100%;
  }

  & + & {
    margin-top: 1.6rem;
  }
}
</style>
